@if (visible) {
  <div class="modal-backdrop" (click)="onClose()"></div>
  <div class="modal">
  <div class="modal-header">
    <h2>Détails du capteur</h2>
    <button class="close-btn" (click)="onClose()">&times;</button>
  </div>
  <div class="modal-body">
    <table>
      <tr><th>Champ</th><th>Valeur</th></tr>
      <tr><td>Numéro de série</td><td>{{ capteur?.numero_serie ?? '' }}</td></tr>
      <tr><td>Date assemblage</td><td>{{ capteur?.date_assemblage ?? '' }}</td></tr>
      <tr><td>Numéro nomenclature</td><td>{{ capteur?.numero_nomenclature ?? ''  }}</td></tr>
      <tr><td>Code MAC</td><td>{{ capteur?.code_mac_carte_electronique ?? ''  }}</td></tr>
      <tr><td>Date emballage</td><td>{{ capteur?.date_emballage ?? '' }}</td></tr>
      <tr><td>Cartouche A</td><td>{{ nomCartoucheA }}</td></tr>
      <tr><td>Cartouche B</td><td>{{ nomCartoucheB }}</td></tr>
      <tr><td>Code bon retour</td><td>{{ capteur?.code_bon_retour ?? '' }}</td></tr>
      <tr><td>Code bon retour cartouches</td><td>{{ capteur?.code_bon_retour_cartouches ?? '' }}</td></tr>
      <tr><td>Référence envoi</td><td>{{ capteur?.reference_envoi ?? '' }}</td></tr>
      <tr><td>Date retour</td><td>{{ capteur?.date_retour ?? '' }}</td></tr>
      <tr><td>Heures fonctionnement</td><td>{{ capteur?.nombre_heures_fonctionnement ?? '' }}</td></tr>
      <tr><td>Litres aspirés</td><td>{{ capteur?.nombre_litres_aspires ?? ''}}</td></tr>
      <tr><td>Présence cartouche</td><td>{{ capteur?.presence_cartouche ? 'Oui' : 'Non' }}</td></tr>
      <tr><td>Test moteur</td><td>{{ capteur?.test_moteur ? 'Oui' : 'Non' }}</td></tr>
      <tr><td>Commentaire</td><td>{{ capteur?.commentaire ?? '' }}</td></tr>
    </table>
  </div>
  <div class="modal-footer">
    <button (click)="onClose()">Fermer</button>
  </div>
  </div>
}

